module.exports = __webpack_public_path__ + "media/images/bg_seminar_mv_pc-47ebc017fb5e501ff84e613aa07373f9.jpg";